import { render, staticRenderFns } from "./logictypelist.vue?vue&type=template&id=842f434e&"
import script from "./logictypelist.vue?vue&type=script&lang=js&"
export * from "./logictypelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports